import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
export function SocialProof() {
  const testimonials = [{
    quote: 'Desde que aplico esto, dejé de fallar por agarre. Mis series ahora terminan cuando el músculo principal se fatiga, no mis manos.',
    author: 'Marcos T.',
    tag: 'Powerlifter'
  }, {
    quote: "Mejoré mis deadlifts sin cambiar nada más en mi rutina. El sistema TriGrip me hizo dar cuenta de lo débil que estaba mi 'Pinch'.",
    author: 'Diego R.',
    tag: 'Crossfit'
  }, {
    quote: 'Nunca entrené el agarre así. Pensé que con colgarme de la barra alcanzaba. La diferencia en control es abismal.',
    author: 'Javier M.',
    tag: 'Calistenia'
  }];
  return <section className="py-24 bg-dark-800 border-y border-dark-700" data-id="element-164">
      <div className="container mx-auto px-4" data-id="element-165">
        <SectionHeading title="RESULTADOS REALES" subtitle="Atletas que ya eliminaron su cuello de botella." data-id="element-166" />

        <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto mt-16" data-id="element-167">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-dark-900 p-8 rounded-2xl border border-dark-700 relative group hover:border-neon-cyan/30 transition-colors" data-id="element-168">
              <Quote className="w-10 h-10 text-neon-cyan/20 absolute top-6 right-6" data-id="element-169" />

              <div className="flex gap-1 mb-6" data-id="element-170">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-neon-cyan fill-neon-cyan" data-id="element-171" />)}
              </div>

              <p className="text-gray-300 font-inter italic mb-8 relative z-10 min-h-[100px]" data-id="element-172">
                "{testimonial.quote}"
              </p>

              <div className="border-t border-dark-700 pt-4" data-id="element-173">
                <p className="text-white font-oswald font-bold text-lg" data-id="element-174">
                  {testimonial.author}
                </p>
                <p className="text-neon-cyan text-sm font-inter" data-id="element-175">
                  {testimonial.tag}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}